import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"

export const getCustomerAccountsByAccountNumber = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const customerIdQuery =
    AccountService.getCustomerIdByAccountNumber(accountNumber)

  if (!customerIdQuery.data) {
    return queries.setData([]).getAggregate()
  }

  const customerAccountsQuery = AccountService.getCustomerAccounts(
    customerIdQuery.data,
  )

  const enrichedData = customerAccountsQuery.data.map((accountNumber) => {
    const customerAccountQuery = AccountService.getAccount(accountNumber)
    queries.add(customerAccountQuery)
    return customerAccountQuery.data
  })

  queries.add(customerIdQuery)
  queries.add(customerAccountsQuery)

  return queries.setData(enrichedData).getAggregate()
}
